var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.checkSensor)?_c('p',[_vm._v("Checking Sensor")]):(_vm.removingSensor)?_c('p',[_vm._v("Removing Sensor")]):(_vm.sensorRemoved)?_c('p',[_vm._v("Sensor Removed")]):(_vm.sensorDNE)?_c('p',[_vm._v("Sensor Doesn't Exist")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }